/* eslint-disable camelcase */
import { IManualInputMaterialData } from '../../../../../../../../../../../../components/dialog-manager/dialogs/enter-manual-input-material-dialog/EnterManualInputMaterialDialog';
import { IComponent } from '../../../../../../../../../../../../shared/interfaces/IComponent';
import { IInputMaterial } from '../../../../PcfWizard.type';

/**
 * Amount, waste/scrap and waste treatment are deliberately left unset: a freshly added
 * material starts empty and is only filled in on its card.
 */
export const mapComponentToInputMaterial = (component: IComponent): IInputMaterial => {
  return {
    id: component.productId,
    material_name: component.productName,
    product_cid: component.productCid,
    pcf_excluding_biogenic: component.pcfExcluding,
    pcf_including_biogenic: component.pcfIncluding,
    declared_unit: component.declaredUnit,
    unitary_product_amount: component.unitaryProductAmount,
  };
};

export const mapManualDataToInputMaterial = (data: IManualInputMaterialData): IInputMaterial => {
  return {
    material_name: data.materialName,
    fossil_ghg_emissions: data.fossilGhgEmissions ?? undefined,
    pcf_excluding_biogenic: data.pcfExcluding,
    pcf_including_biogenic: data.pcfIncluding,
    unitary_product_amount: data.declaredAmount,
    declared_unit: data.declaredUnit,
    source: data.source,
    comment: data.comment,
    quality: 'GOOD', // TODO: This should be set by the button in the dialog
  };
};

export const toInputMaterialPayload = ({
  waste_treatment,
  ...rest
}: IInputMaterial): IInputMaterial => {
  return {
    ...rest,
    waste_treatment_id: waste_treatment?.id ?? null,
  };
};
